import { Link } from 'react-router-dom';
import type { VideoArticle } from '@/mocks/videos';

interface VideoCardProps {
  video: VideoArticle;
}

export default function VideoCard({ video }: VideoCardProps) {
  return (
    <Link
      to={`/article/${video.id}`}
      className="group block bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
    >
      <div className="relative aspect-video overflow-hidden">
        <img
          src={video.thumbnail}
          alt={video.title}
          title={`${video.title} - 福利视频大全`}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute bottom-2 right-2 bg-foreground-900/80 text-background-50 text-xs px-2 py-0.5 rounded-md">
          {video.duration}
        </div>
        {video.hot && (
          <div className="absolute top-2 left-2 bg-primary-500 text-background-50 text-xs px-2 py-0.5 rounded-md font-medium">
            热门
          </div>
        )}
        {video.featured && (
          <div className="absolute top-2 left-2 bg-accent-500 text-foreground-950 text-xs px-2 py-0.5 rounded-md font-medium">
            精选
          </div>
        )}
      </div>
      <div className="p-4">
        <h3 className="text-sm font-semibold text-foreground-950 line-clamp-2 group-hover:text-primary-500 transition-colors mb-2 font-heading leading-snug">
          {video.title}
        </h3>
        <p className="text-xs text-foreground-600 line-clamp-2 mb-3 leading-relaxed">
          {video.excerpt}
        </p>
        <div className="flex items-center justify-between text-xs text-foreground-400">
          <span className="flex items-center gap-1">
            <i className="ri-eye-line"></i>
            {video.views > 10000
              ? `${(video.views / 10000).toFixed(1)}万`
              : video.views}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-heart-line"></i>
            {video.likes > 10000
              ? `${(video.likes / 10000).toFixed(1)}万`
              : video.likes}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-calendar-line"></i>
            {video.date}
          </span>
        </div>
      </div>
    </Link>
  );
}